var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(_vm.src)?_c('img',{attrs:{"src":_vm.src,"alt":"avatar"}}):_c('div',{staticClass:"placeholder"},[_c('v-icon',{staticClass:"mdi mdi-account",attrs:{"small":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }